//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import SideBar from '@/components/SideBar/index'
export default {
  name: 'Home',
  components: {
    Header,
    SideBar,
    Footer,
  },
  watch: {
    $route(to, from) {
      this.getBreadcrumb()
      // 全局拦截是否为当前合作社下或则村集体下，统一添加参数标识
      const paths = ['/village/management/list', '/cooperative/management/list']
      if (
        from.query.$businessType &&
        from.query.$businessType === '_blank' &&
        !paths.includes(to.path)
      ) {
        const {
          $businessId,
          $businessName,
          $businessType,
          $businessAccountId,
          $backPath,
        } = from.query
        const routeResolve = this.$router.resolve({
          path: to.fullPath,
          query: {
            $businessId,
            $businessName,
            $businessType,
            $businessAccountId,
            $backPath,
          },
        })
        this.$router
          .replace({
            path: routeResolve.route.fullPath,
          })
          .catch(() => { })
      }
    },
  },
  methods: {
    getBreadcrumb() {
      if (Object.keys(this.$route.matched[0].meta).length > 0) {
        this.breadList = this.$route.matched
      } else {
        this.breadList = []
      }
    },
  },
}
